/*
 * Cleverroute
 * Cleverroute API
 *
 * OpenAPI spec version: 0.0.2
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.36
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The MetricParamsCost model module.
 * @module model/MetricParamsCost
 * @version 0.0.2
 */
export class MetricParamsCost {
  /**
   * Constructs a new <code>MetricParamsCost</code>.
   * @alias module:model/MetricParamsCost
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>MetricParamsCost</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/MetricParamsCost} obj Optional instance to populate.
   * @return {module:model/MetricParamsCost} The populated <code>MetricParamsCost</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new MetricParamsCost();
      if (data.hasOwnProperty('type'))
        obj.type = ApiClient.convertToType(data['type'], 'String');
      if (data.hasOwnProperty('keepVehicle'))
        obj.keepVehicle = ApiClient.convertToType(data['keepVehicle'], 'Boolean');
      if (data.hasOwnProperty('roundUpTime?'))
        obj.roundUpTime = ApiClient.convertToType(data['roundUpTime?'], 'Boolean');
      if (data.hasOwnProperty('centsFixed'))
        obj.centsFixed = ApiClient.convertToType(data['centsFixed'], 'Number');
      if (data.hasOwnProperty('daysFixed'))
        obj.daysFixed = ApiClient.convertToType(data['daysFixed'], 'Number');
      if (data.hasOwnProperty('centsPerKm'))
        obj.centsPerKm = ApiClient.convertToType(data['centsPerKm'], 'Number');
      if (data.hasOwnProperty('centsPerMinute'))
        obj.centsPerMinute = ApiClient.convertToType(data['centsPerMinute'], 'Number');
      if (data.hasOwnProperty('centsPerHour'))
        obj.centsPerHour = ApiClient.convertToType(data['centsPerHour'], 'Number');
      if (data.hasOwnProperty('centsPerFullDay'))
        obj.centsPerFullDay = ApiClient.convertToType(data['centsPerFullDay'], 'Number');
      if (data.hasOwnProperty('timeDistanceCombinator'))
        obj.timeDistanceCombinator = ApiClient.convertToType(data['timeDistanceCombinator'], 'String');
      if (data.hasOwnProperty('centsActivation'))
        obj.centsActivation = ApiClient.convertToType(data['centsActivation'], 'Number');
    }
    return obj;
  }
}

/**
 * @member {String} type
 */
MetricParamsCost.prototype.type = undefined;

/**
 * wether user keeps the vehicle on arrival
 * @member {Boolean} keepVehicle
 */
MetricParamsCost.prototype.keepVehicle = undefined;

/**
 * whether time cost applies per full hour
 * @member {Boolean} roundUpTime
 */
MetricParamsCost.prototype.roundUpTime = undefined;

/**
 * @member {Number} centsFixed
 */
MetricParamsCost.prototype.centsFixed = undefined;

/**
 * timeframe over which to apply the fixed cost
 * @member {Number} daysFixed
 */
MetricParamsCost.prototype.daysFixed = undefined;

/**
 * @member {Number} centsPerKm
 */
MetricParamsCost.prototype.centsPerKm = undefined;

/**
 * @member {Number} centsPerMinute
 */
MetricParamsCost.prototype.centsPerMinute = undefined;

/**
 * @member {Number} centsPerHour
 */
MetricParamsCost.prototype.centsPerHour = undefined;

/**
 * @member {Number} centsPerFullDay
 */
MetricParamsCost.prototype.centsPerFullDay = undefined;

/**
 * applies to centsPer* values, defaults to `max`, 'sum' | 'max' possible
 * @member {String} timeDistanceCombinator
 */
MetricParamsCost.prototype.timeDistanceCombinator = undefined;

/**
 * @member {Number} centsActivation
 */
MetricParamsCost.prototype.centsActivation = undefined;

